module.exports = __webpack_public_path__ + "static/media/SiteStep3.b1df8a7d.svg";